export const radioGroupContextKey = Symbol('radioGroupContextKey')

export const radioModes = ['radio', 'checkbox']

export const radioShapes = ['label', 'button']